import { connect } from 'react-redux';

import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import fetchSrcDirMetadata from '../actions/fetch-source-dir-metadata';
import SrcDirMetadataFetcher from '../components/src-dir-metadata-fetcher';

type ConnectedSrcDirMetadataFetcherProps = {
  path: string;
};

const mapStateToProps = (
  state: BucketState,
  ownProps: ConnectedSrcDirMetadataFetcherProps
) => {
  const { path } = ownProps;
  const { srcDirMetadata, section } = state.repository.source;
  const { hash } = section;

  return {
    hash,
    srcDirMetadata: hash ? srcDirMetadata[`${hash}:${path}`] : null,
    repository: getCurrentRepository(state),
  };
};

const mapDispatchToProps = { fetchSrcDirMetadata };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SrcDirMetadataFetcher);
